module.exports = __webpack_public_path__ + "static/media/centrepoint-logo_mobile.eb95f6b3.png";